<kendo-grid #grid="remoteBindingDirectiveRef"
            appSiteGridRemoteBinding
            [height]="600"
            [pageSize]="this.PageSize"
            [skip]="this.Skip"
            [sort]="this.Sort"
            [resizable]="true"
            scrollable="virtual"
            [rowClass]="Helper.applyClickedRowClassToClickedRow"
            (cellClick)="this.onCellClick($event)"
            [(filter)]="Helper.Filter"
            [rowHeight]="20"
            [sortable]="SortSettings"
            [filterable]="true">

    <ng-template kendoGridToolbarTemplate>
        @if (ShowAllForAdminButton) {
        <button class="action-btn" mat-raised-button color="primary" (click)="toggleShowAllForAdmin()">{{ShowAllForAdminButtonText}}</button>
        }
        @if (ShowAllForAdminButton) {
        <button class="action-btn" mat-raised-button color="primary" (click)="handleNewSite()">New Site</button>
        }
        @if (ShowAllForAdminButton) {
        <button class="action-btn" mat-raised-button color="primary" (click)="handleSiteImport()">Import Site</button>
        }
        @if (Helper.IsBeingFiltered) {
        <button class="clear-all-filters-btn" mat-stroked-button (click)='Helper.handleClearFilters()'>Clear All Filters</button>
        }
    </ng-template>

    <!--Favorite Icon-->
    @if (!ShowAllForAdmin) {
    <kendo-grid-column [width]="40"
                       [field]="FavoriteColumnDef.fieldName"
                       title=""
                       filter="boolean"
                       [filterable]="true"
                       [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <mat-icon class="command-btn" kendoButton (click)="toggleFavorite(dataItem)" title="Fave this Site">{{favIcon(dataItem)}}</mat-icon>
        </ng-template>
        <kendo-grid-messages filterIsTrue="★" filterIsFalse="☆"></kendo-grid-messages>
    </kendo-grid-column>
    }

    <!--Activation Icon Displayed in Admin mode-->
    @if (ShowAllForAdmin) {
    <kendo-grid-column [width]="40"
                       [field]="FavoriteColumnDef.fieldName"
                       title=""
                       [filterable]="false"
                       [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <mat-icon class="command-btn" kendoButton (click)="toggleActivation(dataItem)" title="Toggle site activation">{{showActivationForAdminIcon(dataItem)}}</mat-icon>
        </ng-template>
    </kendo-grid-column>
    }

    <!--Person Icon Displayed in Admin mode-->
    @if (ShowAllForAdmin) {
    <kendo-grid-column [width]="40"
                       [field]="FavoriteColumnDef.fieldName"
                       title=""
                       [filterable]="false"
                       [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <mat-icon class="command-btn" kendoButton (click)="toggleSiteAdmin(dataItem)" title="Toggle Site Admin">{{showAllForAdminIcon(dataItem)}}</mat-icon>
        </ng-template>
    </kendo-grid-column>
    }

    <!--Trash Icon used to Delete Site-->
    <kendo-grid-command-column [width]="CommandColumnWidth" class="!k-text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="command-column-buttons">
                <button class="button" kendoButton kendoGridFocusable (click)="openSite($event, dataItem)" title="Open Site">Open</button>
                @if (ShowDeleteButtons) {
                <mat-icon class="command-btn" kendoButton (click)="deleteSite($event, dataItem)" title="Delete Site">delete</mat-icon>
                }
            </div>
        </ng-template>
    </kendo-grid-command-column>

    @for (columnDef of this.ColumnDefs; track columnDef; let iColIndex = $index) {
    @if (ShowAllForAdmin || (!ShowAllForAdmin && columnDef.fieldName != 'id')) {
    <kendo-grid-column [field]="columnDef.fieldName"
                       [title]="columnDef.title"
                       [filterable]="true">
        <!-- [width]="columnDef.width"-->
    </kendo-grid-column>
    }
    }
</kendo-grid>

<kendo-contextmenu #gridmenu
                   [items]="this.MenuItems"
                   childrenField="children"
                   svgIconField="svgIcon"
                   separatorField="separator"
                   (select)="this.onContextMenuSelect($event)"></kendo-contextmenu>
